import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-attributes-header',
    styleUrls: ['./attributes-header.component.scss'],
    templateUrl: './attributes-header.component.html'
})
export class AttributesHeaderComponent {

    @Input() countryCode: string;
    @Input() disabledCode: number;
    @Input() disabledSystem: string;
    @Input() disabledSource: string;
    @Input() name: string;
    @Input() tag: string;
    @Input() type: string;
    @Input() subType: string;
    @Input() featureScope: string;

    constructor() {}

}
